import React from 'react';
import ReactDOM from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import './design-system.css';
import './index.css';
import App from './App';
import { msalInstance } from './msalInstance';
import { setupAxiosAuth } from './setupAxiosAuth';

setupAxiosAuth(msalInstance);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>
);
